import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import PropTypes from 'prop-types';
import { Breadcrumbs as CoreBreadcrumbs } from '@vds-core/breadcrumbs';
import { colors } from '@vds/theme';
var propTypes = {
  /*
   * A prop that will invert the colors of the breadcrumbs for use on dark backgrounds.
   *
   */
  inverted: PropTypes.bool
};
var defaultProps = {
  inverted: false
};

var Breadcrumbs = function Breadcrumbs(props) {
  return /*#__PURE__*/React.createElement(CoreBreadcrumbs, _extends({}, props, {
    colorConfig: colors
  }));
};

Breadcrumbs.propTypes = propTypes;
Breadcrumbs.defaultProps = defaultProps;
export default Breadcrumbs;